<!-- LOGO E TITOLO PAGINA -->

<div class="header-container">
  <img src="../../../../assets/images/logo.png" alt="logo" width="200rem" >
</div>

<h1 id="title" class="d-flex justify-content-center title">Registrazione</h1>

<!-- MESSAGGI PAGINA -->

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Errore!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Successo!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<!-- FORM REGISTRAZIONE  -->

<form (ngSubmit)="register()" #form="ngForm" aria-labelledby="title" nbSpinnerSize="giant" nbSpinnerStatus="primary" id="register-form">


  <h5 id="user-info-title" class="d-flex justify-content-start paragraph-title">Test App</h5>

  <!-- Nome e Cognome -->

  <div class="row">

    <div class="form-control-group col">
      <label class="label" for="input-user-name">Nome</label>
      <input nbInput
            [(ngModel)]="user.userName"
            #userName="ngModel"
            id="input-user-name"
            name="userName"
            placeholder="Nome"
            fullWidth
            fieldSize="small"
            [status]="userName.dirty ? (userName.invalid  ? 'danger' : 'success') : 'basic'"
            [required]="getConfigValue('forms.validation.userName.required')"
            [minlength]="getConfigValue('forms.validation.userName.minLength')"
            [maxlength]="getConfigValue('forms.validation.userName.maxLength')"
            [attr.aria-invalid]="userName.invalid && userName.touched ? true : null">
      <ng-container *ngIf="userName.invalid && userName.touched">
        <p class="caption status-danger" *ngIf="userName.errors?.['required']">
          Inserisci il Nome
        </p>
        <p class="caption status-danger" *ngIf="userName.errors?.['minlength'] || userName.errors?.['maxlength']">
          La Nome dovrebbe contenere
          tra i {{getConfigValue('forms.validation.userName.minLength')}}
          e i {{getConfigValue('forms.validation.userName.maxLength')}}
          caratteri
        </p>
      </ng-container>
    </div>

    <div class="form-control-group col">
      <label class="label" for="input-user-surname">Cognome</label>
      <input nbInput
            [(ngModel)]="user.userSurname"
            #userSurname="ngModel"
            id="input-user-surname"
            name="userSurname"
            placeholder="Cognome"
            fullWidth
            fieldSize="small"
            [status]="userSurname.dirty ? (userSurname.invalid  ? 'danger' : 'success') : 'basic'"
            [required]="getConfigValue('forms.validation.userSurname.required')"
            [minlength]="getConfigValue('forms.validation.userSurname.minLength')"
            [maxlength]="getConfigValue('forms.validation.userSurname.maxLength')"
            [attr.aria-invalid]="userSurname.invalid && userSurname.touched ? true : null">
      <ng-container *ngIf="userSurname.invalid && userSurname.touched">
        <p class="caption status-danger" *ngIf="userSurname.errors?.['required']">
          Inserisci il Cognome
        </p>
        <p class="caption status-danger" *ngIf="userSurname.errors?.['minlength'] || userSurname.errors?.['maxlength']">
          La Cognome dovrebbe contenere
          tra i {{getConfigValue('forms.validation.userSurname.minLength')}}
          e i {{getConfigValue('forms.validation.userSurname.maxLength')}}
          caratteri
        </p>
      </ng-container>
    </div>

    </div>

  <div class="row">

    <div class="form-control-group col">
      <label class="label" for="input-user-fiscal-code">telephono</label>
      <input nbInput
            [(ngModel)]="user.userPhone"
            #userPhone="ngModel"
            id="input-user-fiscal-code"
            name="userPhone"
            placeholder="phone"
            fullWidth
            fieldSize="small"
            [pattern]="getConfigValue('forms.validation.phone.regexp')"
            [status]="userPhone.dirty ? (userPhone.invalid  ? 'danger' : 'success') : 'basic'"
            [required]="getConfigValue('forms.validation.phone.required')"
            [minlength]="getConfigValue('forms.validation.phone.minLength')"
            [maxlength]="getConfigValue('forms.validation.phone.maxLength')"
            [attr.aria-invalid]="userPhone.invalid && userPhone.touched ? true : null">
      <ng-container *ngIf="userPhone.invalid && userPhone.touched">
        <p class="caption status-danger" *ngIf="userFiscalCode.errors?.required">
          Inserisci il Codice Fiscale
        </p>
        <p class="caption status-danger" *ngIf="userPhone.errors?.['minlength'] || userPhone.errors?.['maxlength']">
          Il Codice Fiscale non è valido
        </p>
      </ng-container>
    </div>

    <div class="form-control-group col">
      <label class="label" for="input-user-email">Indirizzo Email</label>
      <input nbInput
             [(ngModel)]="user.email"
             #email="ngModel"
             id="input-user-email"
             name="email"
             placeholder="Indirizzo Email"
             fullWidth
             fieldSize="small"
             [pattern]="getConfigValue('forms.validation.email.regexp')"
             [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
             [required]="getConfigValue('forms.validation.email.required')"
             [attr.aria-invalid]="email.invalid && email.touched ? true : null">
      <ng-container *ngIf="email.invalid && email.touched">
        <p class="caption status-danger" *ngIf="email.errors?.['required']">
          Inserisci una Email
        </p>
        <p class="caption status-danger" *ngIf="email.errors?.['pattern']">
          L'Email non è valida
        </p>
      </ng-container>
    </div>
  </div>

  <!-- Password e Conferma Password -->

  <div class="row">

    <div class="form-control-group col">
      <label class="label" for="input-password">Password:</label>
      <input nbInput
            [(ngModel)]="user.password"
            #password="ngModel"
            type="password"
            id="input-password"
            name="password"
            placeholder="Password"
            fullWidth
            fieldSize="small"
            [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
            [required]="getConfigValue('forms.validation.password.required')"
            [minlength]="getConfigValue('forms.validation.password.minLength')"
            [maxlength]="getConfigValue('forms.validation.password.maxLength')"
            [attr.aria-invalid]="password.invalid && password.touched ? true : null">
      <ng-container *ngIf="password.invalid && password.touched">
        <p class="caption status-danger" *ngIf="password.errors?.['required']">
          Inserisci una password!
        </p>
        <p class="caption status-danger" *ngIf="password.errors?.['minlength'] || password.errors?.['maxlength']">
          La password deve avere
          dai {{ getConfigValue('forms.validation.password.minLength') }}
          ai {{ getConfigValue('forms.validation.password.maxLength') }}
          caratteri
        </p>
      </ng-container>
    </div>

    <div class="form-control-group col">
      <label class="label" for="input-re-password">Conferma Password:</label>
      <input nbInput
            [(ngModel)]="user.confirmPassword"
            #rePass="ngModel"
            type="password"
            id="input-re-password"
            name="rePass"
            placeholder="Conferma Password"
            fullWidth
            fieldSize="small"
            [status]="rePass.dirty ? (rePass.invalid || password.value != rePass.value  ? 'danger' : 'success') : 'basic'"
            [required]="getConfigValue('forms.validation.password.required')"
            [attr.aria-invalid]="rePass.invalid && rePass.touched ? true : null">
      <ng-container *ngIf="rePass.invalid && rePass.touched">
        <p class="caption status-danger" *ngIf="rePass.errors?.['required']">
          Devi confermare la password!
        </p>
        <p class="caption status-danger" *ngIf="password.value != rePass.value && !rePass.errors?.['required']">
          Le password non corrispondono!
        </p>
      </ng-container>
    </div>

  </div>

  <!-- Pulsante Registrati -->

  <button nbButton
          fullWidth
          status="primary"
          size="large"
          [disabled]="submitted || !form.valid"
          [class.btn-pulse]="submitted">
    Registrati
  </button>
</form>

<section class="another-action" aria-label="Sign in">
  Hai gia un account? <a class="text-link" [routerLink]="['/auth/login']" routerLinkActive="active">Accedi</a>
</section>
